import Player from '@/models/PlayerScore/player';

export default class PlayerScore {
  constructor({
    uuid = null,
    player = null,
    decisiveScore = null,
    detailedScore = null,
    totalScore = null,
    minutesPlayed = null,
    onGameSheet = null,
    updatedAt = null,
  } = {}) {
    this.uuid = uuid;
    this.player = Player.createFromObject(player);
    this.decisiveScore = decisiveScore;
    this.detailedScore = detailedScore;
    this.totalScore = totalScore;
    this.minutesPlayed = minutesPlayed;
    this.onGameSheet = onGameSheet;
    this.updatedAt = new Date(updatedAt);
  }

  static createFromObject(data) {
    return new PlayerScore(data);
  }

  static createCollectionFromObject(data) {
    return data.map(
      (playerScoreData) => PlayerScore.createFromObject(playerScoreData),
    );
  }
}
